import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AppRoutes, FundService } from '@gs-2.0/core';

import FundTypes from '../constants/fund-types';

export const vendorFundRouteGuard: CanActivateFn = () => {
  const fundService = inject(FundService);
  const router = inject(Router);

  const fundType = fundService.fundType();
  const isVendor =
    fundType === FundTypes.CHARITY ||
    fundType === FundTypes.PROJECT ||
    fundType === FundTypes.PROJECT_CHARITY;

  if (isVendor) {
    router.navigate([AppRoutes.FUND_DASHBOARD]);
    return false;
  }

  return true;
};
